import React, { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import fa from "./locales/fa.json";
import SectionHeader from "../../SectionHeader";
import FeatureTabs from "./FeatureTabs";
import FeatureContent from "./FeatureContent";
import {
    LocationWidget,
    GeofenceWidget,
    SchoolModeWidget,
    RemindersWidget,
    DeviceLockWidget,
    FindDeviceWidget,
    RemoteRebootWidget,
    RemoteShutdownWidget,
    DigitalWalletWidget,
    FamilySharingWidget,
    EmergencyContactsWidget,
    SmartNotificationsWidget,
    MoodCheckinWidget,
    RewardsTasksWidget,
} from "./widgets";
import { buildTabsFromTranslation } from "./tabsConfig";

const widgetMap: Record<string, React.ComponentType<any>> = {
    location: LocationWidget,
    geofence: GeofenceWidget,
    schoolMode: SchoolModeWidget,
    reminders: RemindersWidget,
    deviceLock: DeviceLockWidget,
    findDevice: FindDeviceWidget,
    remoteReboot: RemoteRebootWidget,
    remoteShutdown: RemoteShutdownWidget,
    digitalWallet: DigitalWalletWidget,
    familySharing: FamilySharingWidget,
    emergencyContacts: EmergencyContactsWidget,
    smartNotifications: SmartNotificationsWidget,
    moodCheckin: MoodCheckinWidget,
    rewardsTasks: RewardsTasksWidget,
};

const NonHealthFeatures: React.FC = () => {
    const [activeTab, setActiveTab] = useState("location");
    const { t, i18n } = useTranslation("nonHealth");

    React.useEffect(() => {
        i18n.addResourceBundle("fa", "nonHealth", fa, true, true);
    }, [i18n]);

    const tabs = buildTabsFromTranslation(t);
    const activeTabData = tabs.find((tab) => tab.id === activeTab) || tabs[0];
    const ActiveWidget = widgetMap[activeTab];

    return (
        <section dir="rtl" className="py-16 md:py-28 overflow-hidden">
            <div className="container mx-auto px-4 sm:px-10">
                <SectionHeader
                    regularText={t("sectionHeader.regularText")}
                    highlightedText={t("sectionHeader.highlightedText")}
                    descriptionHighlight={t("sectionHeader.descriptionHighlight")}
                    descriptionText={t("sectionHeader.descriptionText")}
                />

                <div className="mt-8">
                    <FeatureTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

                    <div className="flex flex-col md:flex-row items-start gap-8 lg:gap-12 bg-white/50 backdrop-blur-md p-5 md:p-8 rounded-2xl shadow-xl border border-gray-200/50 min-h-[450px]">
                        <FeatureContent activeTab={activeTab} tabs={tabs} />

                        {/* ویجت تعاملی */}
                        <div className="w-full md:w-1/3 flex justify-center self-center">
                            <AnimatePresence mode="wait">{ActiveWidget && <ActiveWidget key={activeTab + "-widget"} color={activeTabData.color} />}</AnimatePresence>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NonHealthFeatures;
